import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import LittersCurrent from '../components/litters-current'
import Footer from '../components/footer'
import './kittens.css'

const Kittens = (props) => {
  return (
    <div className="kittens-container1">
      <Helmet>
        <title>Kittens - Sycorax Cats</title>
        <meta property="og:title" content="Kittens - Sycorax Cats" />
        <link
          rel="canonical"
          href="https://sycorax.uk/kittens"
        />
        <meta
          property="og:url"
          content="https://sycorax.uk/kittens"
        />
      </Helmet>
      <Navigation></Navigation>
      <LittersCurrent></LittersCurrent>
      <section className="litters-past">
        <div className="litters-container">
          <header className="litters-header">
            <h2 className="section-title">Past Litters</h2>
            <p className="section-subtitle">
              None yet, awaiting our first litter by September 2026!
            </p>
          </header>
          <div className="litters-footer">
            <Link to="/contact-us" className="kittens-navlink">
              <div className="kittens-thq-btn-elm btn-primary btn-lg btn">
                <span>Inquire About Future Litters</span>
              </div>
            </Link>
          </div>
        </div>
      </section>
      <div className="kittens-container2">
        <div className="kittens-container3">
          <Script
            html={`<script defer data-name="kitten-gallery-logic">
(function(){
  // Past Litter Masonry Interaction
  // Since we are not using animations, this script handles simple image expansions or label visibility if needed
  // For this simple artistic site, the hover states are handled via CSS (instant changes).
  // No complex JS needed for this layout.

  const masonryItems = document.querySelectorAll(".masonry-item")

  masonryItems.forEach((item) => {
    item.addEventListener("click", () => {
      // Logic for opening a lightbox could go here in a production environment
      // For now, we maintain the static creative display as requested
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Kittens
